import { FC } from 'react'
import { Box } from '@mui/material'
import { RpBonusesTable } from '../../components'

const Bonuses: FC = () => {
  return (
    <Box>
      <RpBonusesTable />
    </Box>
  )
}

export default Bonuses
